/** @format */

import { Component, Input, OnInit } from '@angular/core';

import { ExclusiveProductContent } from '../exclusive-product-content.interface';
import { FileService } from '@shared/data-access/services';
import { pdpJsonFileName } from '@pdp/data-access/constants';

import { BypassSanitizationPipe } from '@shared/utils/pipes';
import {
	HomefieldIconLibraryModule,
	HomefieldIconsLibraryService,
	homefieldIconNikeMember
} from '@dsg-tech/homefield-angular-icons';
import { take } from 'rxjs/operators';

@Component({
	selector: 'pdp-exclusive-product-promo-message',
	templateUrl: './exclusive-product-promo-message.component.html',
	styleUrl: './exclusive-product-promo-message.component.scss',
	imports: [HomefieldIconLibraryModule, BypassSanitizationPipe]
})
export class ExclusiveProductPromoMessageComponent implements OnInit {
	/**
	 * @description String representing the brand of the exclusive product.
	 */
	@Input()
	public brand: string;

	/**
	 * @description Used to reference the json file to reference the correct
	 * data for this exclusive product.
	 */
	public content: ExclusiveProductContent;

	constructor(
		public fileService: FileService,
		homefieldIconsLibraryService: HomefieldIconsLibraryService
	) {
		homefieldIconsLibraryService.registerIcons([homefieldIconNikeMember]);
	}

	ngOnInit(): void {
		const EXCLUSIVE_CONTENT = this.fileService.getDataFileByType$(
			pdpJsonFileName.exclusiveContent,
			'json'
		);

		EXCLUSIVE_CONTENT.pipe(take(1)).subscribe((values) => {
			this.content = values[this.brand];
		});
	}
}
